export const REQUEST_AUTHENTICATION = "REQUEST_AUTHENTICATION";
export const RECEIVE_AUTHENTICATION_DATA = "RECEIVE_AUTHENTICATION_DATA";
export const RECEIVE_AUTHENTICATION_ERROR = "RECEIVE_AUTHENTICATION_ERROR";

export const GET_RECRUITER_LOGO = "GET_RECRUITER_LOGO";
export const SET_RECRUITER_LOGO = "SET_RECRUITER_LOGO";
export const GET_RECRUITER_LOGO_ERROR = "GET_RECRUITER_LOGO_ERROR";
export const SET_MODE = "SET_MODE";
